module.exports = __webpack_public_path__ + "static/media/logo.7c81437b.svg";